/**
 * TODO: migrate to skooldio-ui-components
 *
 **/
import { space, layout, flexbox, typography, color } from 'styled-system';
import styled from 'styled-components';

const Box = /** @type {import('styled-components').ThemedStyledFunction<"div", any, Props, never>} */ (
  styled('div')
)`
  ${space};
  ${typography};
  ${color};
  ${layout};
  ${flexbox};
`;

export default Box;

/** @typedef {import('styled-system').SpaceProps} SpaceProps */
/** @typedef {import('styled-system').TextStyleProps} TextStyleProps */
/** @typedef {import('styled-system').ColorProps} ColorProps */
/** @typedef {import('styled-system').LayoutProps} LayoutProps */
/** @typedef {import('styled-system').FlexboxProps} FlexboxProps */

/** @typedef {SpaceProps & TextStyleProps & ColorProps & LayoutProps & FlexboxProps} Props */
